import React, {Component, PropTypes} from 'react';
import styled from 'styled-components';
import {
  Col,
} from '@sketchpixy/rubix';
import {
  getPaymentDetail
} from '../../../api/api';
import NumberFormat from "react-number-format";

const Root = styled(Col)`
  padding: 0;
`;


const Container = styled.div`
  display: flex;
  flex-flow: column;
  border-bottom: ${props => props.expand ? '2px' : '1px'} solid #d8d8d8;

`;

const Title = styled.div`
  height: 65px;
  font-weight: bold;
  color: black;
  display: flex;
  align-items: center;
  font-size: 18px;
`;
const ItemTitle = styled.div`
  width: 202px;
  font-size: 16px;
`;

const Item = styled.div`
  display: flex;
  min-height: 60px;
  text-align: justify;
   
  &:last-child {
    border-bottom: 0;
  }
  
  & div:first-child {
    color: black;
  }
  
  & div {
    margin-top: auto;
    margin-bottom: auto;
    padding: 0;
  }
`;

const Amount = styled.div`
  width: 120px;
  font-weight: bold;
`;


const BlueAmount = styled.div`
  width: 120px;
  color: blue;
  font-weight: bold;
`;


const RedAmount = styled.div`
  width: 120px;
  color: red;
  font-weight: bold;
`;

class BalanceInfo extends Component {
  constructor(props) {
    super(props);

    this.state = {
      payment: {}
    };
  }

  componentDidMount() {
    this.getPaymentDetail(this.props.contract.contractId);
  }
  componentWillReceiveProps(nextProps) {
    this.getPaymentDetail(nextProps.contract.contractId);
  }


  displayAmount = (amount) => {
    const scientificNotation = Math.pow(10, this.props.decimalScale * -1);
    return (amount * scientificNotation).toFixed(2);
  };


  billingDateChangeHandler = (nextPaymentDate) => {
    this.setState({
      nextPaymentDate: nextPaymentDate.getTime()
    });
  };

  getExpectedPaymentDate = () => {
    return this.state.nextPaymentDate;
  };


  opportunityLinkChangeHandler = (event) => {
    this.setState({
      opportunityLink: event.target.value
    });
  };

  getPaymentDetail(contractId) {
    getPaymentDetail(contractId, (err, result) => {
      if (err) {
        Messenger().post({
          type: 'error',
          message: `${err.message} (${err.statusCode})`,
          showCloseButton: true,
        });
      } else {
        const payment = result.detail;
        this.setState({
          payment,
          nextPaymentDate: payment.nextPaymentDate
        });

      }
    });
  }


  render() {
    return (
        <Root xs={12}>
          <Title>Balance</Title>
          <Container>
            <Item>
              <ItemTitle>Total Amount</ItemTitle>
              <NumberFormat
                  displayType="text"
                  thousandSeparator
                  prefix={`${this.props.currency} `}
                  decimalScale={this.props.decimalScale}
                  fixedDecimalScale
                  value={this.displayAmount(this.state.payment.totalAmount)}
                  renderText={value => <Amount>{value}</Amount>}
              />
            </Item>
            <Item>
              <ItemTitle>Paid</ItemTitle>
              <NumberFormat
                  displayType="text"
                  thousandSeparator
                  prefix={`${this.props.currency} `}
                  decimalScale={this.props.decimalScale}
                  fixedDecimalScale
                  value={this.displayAmount(this.state.payment.paidAmount)}
                  renderText={value => <BlueAmount>{value}</BlueAmount>}
              />
            </Item>
            <Item>
              <ItemTitle>Remaining Amount</ItemTitle>
              <NumberFormat
                  displayType="text"
                  thousandSeparator
                  prefix={`${this.props.currency} `}
                  decimalScale={this.props.decimalScale}
                  fixedDecimalScale
                  value={this.displayAmount(this.state.payment.remainingAmount)}
                  renderText={value => <RedAmount>{value}</RedAmount>}
              />
            </Item>
          </Container>
        </Root>
    );
  }
}

BalanceInfo.propTypes = {
  contract: PropTypes.shape({
    contractId: PropTypes.number,
    currencyName: PropTypes.string,
    currencyCode: PropTypes.string,
    currencyString: PropTypes.string,
    contractSalesRepEmail: PropTypes.string,
    contractPatientEmail: PropTypes.string,
    contractPgType: PropTypes.string,
    contractPgBillingKey: PropTypes.string,
    contractDevicesDetail: PropTypes.string,
    contractBillingDate: PropTypes.number,
    nextPaymentDate: PropTypes.string,
    contractStatus: PropTypes.string,
    installmentPeriod: PropTypes.number,
    contractOnetimeAmount: PropTypes.number,
    contractHardwareAmount: PropTypes.number,
    contractPostalCode: PropTypes.string,
    contractTaxRate: PropTypes.number,
    patientSubscription: PropTypes.object,
    payments: PropTypes.array,
    schedule: PropTypes.object,
    opportunityLink: PropTypes.string,
    createdTime: PropTypes.number,
    updatedTime: PropTypes.number,
  }).isRequired,
};


export default BalanceInfo;



// WEBPACK FOOTER //
// ./src/routes/patient/PaymentInfo/BalanceInfo.js